import { ReactNode } from 'react';
import { PopupPlacementType } from './type';

export function PopupRoot({
  popupId,
  setPopoverRef,
  placement,
  children,
  styles,
  attributes,
  onClick,
  onMouseEnter,
  onMouseLeave,
  width,
}: {
  children: ReactNode;
  popupId: string;
  setPopoverRef: any;
  styles: any;
  width?: string;
  attributes: any;

  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  placement?: PopupPlacementType;
}) {
  return (
    <div
      className={`popup-root z-50 ${
        placement === 'screen-centered' ||
        placement === 'screen-offset-top' ||
        placement === 'stick-to-bottom'
          ? 'w-screen h-screen grid'
          : ''
      }`}
      ref={setPopoverRef}
      style={styles.popper}
      {...attributes.popper}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        id={`popup-${popupId}`}
        onClick={(e) => e.stopPropagation()}
        className={`animate-fade ${
          placement === 'screen-centered' || placement === 'screen-offset-top'
            ? 'justify-self-center mt-[5vh]'
            : placement === 'stick-to-bottom'
            ? 'w-full h-full flex flex-col justify-end'
            : ''
        }`}
        style={{
          width,
        }}
      >
        {children}
      </div>
    </div>
  );
}
